/**
 * Routes whose page runs edge to edge inside MainLayout's <main>.
 *
 * <main> owns the page padding (p-6) since v1.227.0, so a full-height canvas or
 * kiosk page has to opt out explicitly — never by guesswork. The pages listed
 * here also carry a `// page-padding-exempt: <reason>` comment, which is what
 * `scripts/check-page-padding.js` reads.
 *
 * Print routes are NOT here: they render outside MainLayout altogether.
 */
const FULL_BLEED_PATTERNS = [
  /^\/clients\/[^/]+\/topology\/?$/, // AssetTopologyPage — topology canvas
  /^\/kb\/workflow-builder(\/[^/]+)?\/?$/, // WorkflowBuilderPage — full-height canvas
  /^\/roadmap\/?$/, // RoadmapPage — full-height board
  /^\/scheduler\/?$/, // SchedulerPage — full-height drag-and-drop
  /^\/goods-in\/?$/, // GoodsInPage — full-screen kiosk
];

export const isFullBleedRoute = (pathname) =>
  FULL_BLEED_PATTERNS.some((re) => re.test(pathname || ''));

export default FULL_BLEED_PATTERNS;
